module.exports = __webpack_public_path__ + "img/gracie-relax.2e2fee2f.jpg";